import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from '../../../../../shared/models/module-manager';

@Component({
    selector: 'coaching-status-settings',
    templateUrl: './coaching-status-settings.component.html',
    styleUrls: ['./coaching-status-settings.component.scss']
})
export class CoachingStatusSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    // For additional filters
    selectedMetrics = [16890, 16889];

    constructor() {}

    ngOnInit() {
        this.moduleManager.customSettingsAdded = true;
    }
}
